//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'Cpts005',
        components: {

        },
        props: {
            data: Array
        }
    }
